import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx'
import './index.css'
import "./lib/sentry";
import { ErrorFallback } from "./components/ErrorFallback";
import { initPerformanceOptimizations } from "./lib/performance";
import { registerServiceWorker } from "./lib/sw-register";

// Initialize performance optimizations
initPerformanceOptimizations();

// Register service worker for offline support and caching
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <Sentry.ErrorBoundary
      fallback={(errorData) =>
        <ErrorFallback error={errorData.error as Error} resetError={errorData.resetError} />
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </HelmetProvider>
);
